import { CONSTANT } from "../../../../../constant/Constant";

export const YouTubeEmbed = ({ url, flower }) => {
  let videoId = "";

  try {
    const parsedUrl = new URL(url);
    if (parsedUrl.hostname === "youtu.be") {
      videoId = parsedUrl.pathname.slice(1); // after the slash
    } else {
      videoId = parsedUrl.searchParams.get("v");
    }
  } catch (error) {
    console.error("Invalid YouTube URL");
  }

  const embedUrl = `https://www.youtube.com/embed/${videoId}`;

  return (
    <>
      <div className="flex justify-end">
        <img
          src={`${CONSTANT.UI_URL}flower/${flower}`}
          alt="flower"
          className="h-50 rotate-[180deg]"
        />
      </div>
      <div className="w-full aspect-video flex justify-center items-center">
        <iframe
          className="w-[70%] h-[70%]"
          src={embedUrl}
          title="YouTube video player"
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        ></iframe>
      </div>
    </>
  );
};
